var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { compact } from 'lodash';
import { classNames } from '@shapeable/utils';
import { TabsContainer } from './tabs-container';
import { useLang } from '../hooks/use-lang';
import { ContentTab } from './content-tab';
var cls = classNames('content-tabs');
export var ContentTabsDefaultProps = {
  activeTab: 'all',
  items: []
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: flex-start;\n    width: 100%;\n    flex-direction: row;\n  "], ["\n    display: flex;\n    align-items: flex-start;\n    width: 100%;\n    flex-direction: row;\n  "]))),
  desktop: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TabsStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ContentTabstyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Tabs: styled(TabsContainer)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), TabsStyles),
  Tab: styled(ContentTab)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContentTabstyles)
};
export var ContentTabs = function (props) {
  var className = props.className,
    onTabClick = props.onTabClick,
    items = props.items,
    activeTab = props.activeTab,
    colors = props.colors,
    AppTabs = props.AppTabs;
  var t = useLang();
  // const { isReady } = useReady();
  var handleClick = function (tab) {
    return function () {
      if (onTabClick) {
        onTabClick(tab.id);
      }
    };
  };
  // if (!isReady) {
  //   // there's little point ever rendering these if not yet hydrated, as they use hash state to manage active tab
  //   return null;
  // }
  if (typeof window === 'undefined') {
    return null;
  }
  ;
  return React.createElement(My.Container, null, React.createElement(My.Tabs, {
    showFade: false,
    className: cls.name(className)
  }, compact(items).map(function (tab, index) {
    var hasLabelAndIcon = !!tab.label && !!tab.icon;
    return React.createElement(My.Tab, {
      isLoading: tab.isLoading,
      onClick: handleClick(tab),
      key: tab.id,
      count: tab.count,
      isActive: activeTab === tab.id,
      icon: tab.icon,
      label: tab.label,
      colors: colors
    });
  })));
};
ContentTabs.cls = cls;
ContentTabs.defaultProps = ContentTabsDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;